import React, { useCallback, useEffect, useMemo } from 'react'
import { Form, Row, Spin } from 'antd'
import { isEmpty } from 'lodash'

import {
  DirtyPromptForm,
  FormButtons,
  FormImageUpload,
} from '../../../common/components/sections'
import { PERMISSIONS } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useFormDirty, useUserHasPermissions } from '../../../common/hooks'

import { useUpdateFoodMoodImageDetailsMutation } from '../../hooks'
import { foodMoodPropType } from '../../prop-types'

import { foodMoodImageFormInitialValues } from './initial-values'

const FoodMoodImageDetailsForm = ({ foodMood }) => {
  const [form] = Form.useForm()

  const isFormEnabled = useUserHasPermissions([
    PERMISSIONS.FOOD_MOOD.UPDATE_IMAGE_DETAILS,
  ])

  const [
    updateFoodMoodImageDetails,
    { isLoading: isSaveLoading, error: saveError },
  ] = useUpdateFoodMoodImageDetailsMutation()

  const initialValues = useMemo(
    () => foodMoodImageFormInitialValues(foodMood),
    [foodMood],
  )

  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const handleSaveData = useCallback(
    data => updateFoodMoodImageDetails(foodMood.id, data),
    [foodMood.id, updateFoodMoodImageDetails],
  )

  useEffect(() => {
    if (saveError) {
      showErrorNotification({
        title: 'FoodMood details error',
        description: saveError,
      })
    }
  }, [saveError])

  useEffect(() => {
    resetForm()
  }, [foodMood.imageUrl, resetForm])

  return isSaveLoading || isEmpty(initialValues) ? (
    <Spin />
  ) : (
    <>
      <DirtyPromptForm
        isDirty={isDirty}
        form={form}
        initialValues={initialValues}
        name="foodMoodImageForm"
        onFinish={handleSaveData}
        autoComplete="off"
        onFieldsChange={setToDirty}
      >
        <Row>
          <FormImageUpload
            disabled={!isFormEnabled}
            labelAbove
            name="image"
            label="Image"
          />
        </Row>
        <FormButtons
          permissions={[PERMISSIONS.FOOD_MOOD.UPDATE_IMAGE_DETAILS]}
          isDisabled={!isDirty}
          onReset={resetForm}
        />
      </DirtyPromptForm>
    </>
  )
}

FoodMoodImageDetailsForm.propTypes = {
  foodMood: foodMoodPropType.isRequired,
}

export default FoodMoodImageDetailsForm
